module.exports = __webpack_public_path__ + "img/Misi Working Style-Icon Intelligent0.3607fd0e.png";